import type { FC } from 'react';
import React, { useEffect } from 'react';
import cn from 'classnames';

import { defaultHandler } from './config';
import type { IAutoCompleteProps } from './models';
import defaultStyles from './styles/styles.css';
import { getScroll } from './helpers/actions';

export const Autocomplete: FC<IAutoCompleteProps> = ({
    autocompleteRef,
    highlightedItem = -1,
    onSelect = defaultHandler,
    options,
    position,
    styles: injectedStyles,
}) => {
    const styles = { ...defaultStyles, ...injectedStyles };

    useEffect(() => {
        if (highlightedItem < 0) return;

        if (autocompleteRef.current) {
            const top = getScroll(highlightedItem, autocompleteRef.current.scrollTop);

            autocompleteRef.current.scrollTo?.({ top });
        }
    }, [highlightedItem, autocompleteRef]);

    return (
        <ul
            ref={autocompleteRef}
            className={cn(styles.autocomplete, styles[position])}
            role="listbox"
            tabIndex={-1}
        >
            {options.map((option, index) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <li
                    key={option.id}
                    aria-selected={index === highlightedItem}
                    className={styles.option}
                    onClick={event => onSelect({ event, value: index })}
                    role="option"
                >
                    {option.label}
                </li>
            ))}
        </ul>
    );
};
